import React from 'react';
import { FileText } from 'lucide-react';

interface PropostaConditionsProps {
  formData: any;
  setFormData: (data: any) => void;
}

export function PropostaConditions({ formData, setFormData }: PropostaConditionsProps) {
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
      <h3 className="text-lg font-semibold text-slate-800 mb-4 flex items-center gap-2">
        <FileText className="w-5 h-5 text-red-600" />
        Termos e Condições
      </h3>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1.5">Considerações Gerais / Escopo</label>
          <textarea
            className="w-full border border-slate-300 rounded-lg px-4 py-3 bg-white text-slate-700 outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 text-sm resize-y"
            placeholder="Descreva o escopo do serviço, itens fora do escopo, responsabilidades, etc."
            value={formData.consideracoes}
            onChange={e => setFormData({...formData, consideracoes: e.target.value})}
            rows={4}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Condições Comerciais</label>
            <textarea
              className="w-full border border-slate-300 rounded-lg px-4 py-3 bg-white text-slate-700 outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 text-sm resize-y"
              placeholder="Ex: Valores não contemplam seguro de carga, validade da proposta de 15 dias..."
              value={formData.condicoes_comerciais}
              onChange={e => setFormData({...formData, condicoes_comerciais: e.target.value})}
              rows={5}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Condições de Pagamento</label>
            <textarea
              className="w-full border border-slate-300 rounded-lg px-4 py-3 bg-white text-slate-700 outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 text-sm resize-y"
              placeholder="Ex: Faturamento quinzenal após execução dos serviços, boleto com vencimento para 15 dias..."
              value={formData.condicoes_pagamento}
              onChange={e => setFormData({...formData, condicoes_pagamento: e.target.value})}
              rows={5}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
